import React, { useState, useEffect } from 'react';
import { MQTTProtocol } from '../setup-senzmatica/connect-devices/MQTTProtocol';
import { HTTPProtocol } from '../setup-senzmatica/connect-devices/HTTPProtocol';
import useStyles from '../maintenance/assets/styles';
import {makeStyles, Theme } from '@material-ui/core';
import { SearchableSelect } from './SearchableSelect';
import { AddableSelect } from '../../components/sub-components/AddableSelect';
import { getAllDevices } from '../testing-automation/api-helper/apiHelper';
import { ToasterComponent } from '../maintenance/test-automation/components/Toaster';
export function DeviceForm({
  onClose,
  onSubmit,
  allDevices,
  isCloning,
  selectedDevice,
  formType,
  sensors,
  actuators,
  batches,
  allProducts,
  hasPermissionFor,
  setCodecId,
  codecs,
  setLoading,
  setIsAddPopupOpen,
  formData,
  setFormData,
  selectedProductTypeDetails,
  setSelectedProductTypeDetails,
  availableVersions,
  setAvailableVersions,
  errors,
  setErrors
}) {

  const style = useStyles();
  const [sensorsOfDevice, setSensorsOfDevice] = useState([]);
  const [actuatorsOfDevice, setActuatorsOfDevice] = useState([]);
  const [addCredentialsSuccess, setAddCredentialsSuccess] = useState(false);
  const [credentialsError, setCredentialsError] = useState(false);
  const [isProtocolAdded, setIsProtocolAdded] = useState(false);
  const [clientId, setClientId] = useState("");
  const [isAdding, setIsAdding] = useState(true);
  const [isAddBatchClick, setIsAddBatchClick] = useState(false);
  const [batchError, setBatchError] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [otaUpgradable, setOtaUpgradable] = useState(false);

  const [modelOptions, setModelOptions] = useState<string[]>([]);
  const [locationOptions, setLocationOptions] = useState<string[]>([]);
  const [dbDevices, setDbDevices] = useState<any[]>([]);

  // Toaster state
  const [isToasterOpen, setIsToasterOpen] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [reqSuccess, setReqSuccess] = useState(false);

  useEffect(() => {
    if (formType === "EDIT") {
      if (setLoading) setLoading(true);
      getAllDevices("MODEL_LOCATION")
        .then((devices: any) => {
          if (devices) {
            setDbDevices(devices);
          }
        })
        .catch((err) => {
          console.error("Failed to load model and location options:", err);
          setReqSuccess(false);
          const errMsg = (err.response && err.response.data && err.response.data.message) || err.message || "Failed to load Model ID and Location options from server.";
          setToasterMessage(errMsg);
          setIsToasterOpen(true);
          setTimeout(() => setIsToasterOpen(false), 3000);
        })
        .finally(() => {
          if (setLoading) setLoading(false);
        });
    }
  }, [formType]);

  useEffect(() => {
    if (dbDevices.length > 0) {
      const models = Array.from(new Set(dbDevices.map(d => d.deviceModel).filter(Boolean))) as string[];
      const locations = Array.from(new Set(dbDevices.map(d => d.metaData && d.metaData.location).filter(Boolean))) as string[];
      
      if (selectedDevice) {
        if (selectedDevice.deviceModel && !models.includes(selectedDevice.deviceModel)) {
          models.push(selectedDevice.deviceModel);
        }
        const loc = selectedDevice.metaData && selectedDevice.metaData.location;
        if (loc && !locations.includes(loc)) {
          locations.push(loc);
        }
      }
      
      setModelOptions(models);
      setLocationOptions(locations);
    } else if (selectedDevice) {
      const models = selectedDevice.deviceModel ? [selectedDevice.deviceModel] : [];
      const loc = selectedDevice.metaData && selectedDevice.metaData.location;
      const locations = loc ? [loc] : [];
      setModelOptions(models);
      setLocationOptions(locations);
    }
  }, [dbDevices, selectedDevice]);

  const handleAddModelOption = (newModel: string) => {
    if (newModel && !modelOptions.includes(newModel)) {
      setModelOptions(prev => [...prev, newModel]);
    }
  };

  const handleAddLocationOption = (newLoc: string) => {
    if (newLoc && !locationOptions.includes(newLoc)) {
      setLocationOptions(prev => [...prev, newLoc]);
    }
  };

  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    console.log(selectedDevice);
    if(formType === "EDIT") {
      setIsAdding(false);
      setCredentialsError(false);
      setAddCredentialsSuccess(true);
      setIsProtocolAdded(true);
    }
    if (selectedDevice) {

      setFormData({
        id: selectedDevice.id || '',
        name: selectedDevice.name || '',
        interval: selectedDevice.interval.toString() || '',
        persistence: selectedDevice.persistence ? true : false,
        protocol: selectedDevice.protocol || 'MQTT',
        connectivity: selectedDevice.connectivity || 'GSM',
        batchNumber: selectedDevice.batchNumber || '',
        simNumber: selectedDevice.simNumber || '',
        sensorCodes: selectedDevice.sensorCodes || [],
        actuatorCodes: selectedDevice.actuatorCodes || [],
        productType: selectedDevice.productType || '',
        productId:selectedDevice.productId || '',
        productVersion : selectedDevice.productVersion || '',
        deviceModel: selectedDevice.deviceModel || '',
        location: (selectedDevice.metaData && selectedDevice.metaData.location) || ''
      });

      setSensorsOfDevice(selectedDevice.sensorCodes || []);
      setActuatorsOfDevice(selectedDevice.actuatorCodes || []);

      if (selectedDevice.productType) {
        const product = allProducts.find(p => p.productName === selectedDevice.productType);
        if (product) {
          setOtaUpgradable(product.otaUpgradable);
          setSelectedProductTypeDetails(product);
          if (product.codecName) {
            const filterCodec = codecs.find(codec => codec.codecName == product.codecName);
            if (filterCodec) setCodecId(filterCodec.id);
          }
          if (product.versions) {
            let filteredVersions = product.versions.filter(version => version.versionNum !== "0.0.0");  
            setAvailableVersions(filteredVersions);
          }
        }
      }
    }
  }, [selectedDevice]);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "productType") {
      setErrors((prevError) =>({
        ...prevError,
        productType:null
      }))
      const product = allProducts.find(p => p.productName === value);
      if (!product) {
        setFormData((prev: any) => ({ ...prev, productType: value }));
        return;
      }
      if (product.codecName) {
        const filterCodec = codecs.find(codec => codec.codecName == product.codecName)
        if (filterCodec) {
          setCodecId(filterCodec.id)
        }
      }
      if (product) {
        setFormData(prev => ({
          ...prev,
          productType: product.productName,
          persistence: product.persistence,
          protocol: product.protocol,
          connectivity: product.connectivity,
          sensorCodes: product.sensorCodes || [],
          actuatorCodes: product.actuatorCodes || [],
        }));
        setSensorsOfDevice(product.sensorCodes || []);
        setActuatorsOfDevice(product.actuatorCodes || []);
        setOtaUpgradable(product.otaUpgradable)
        setSelectedProductTypeDetails(product);
        if(product.versions){
          let filteredVersions=product.versions.filter(version => version.versionNum !== "0.0.0");  
          setAvailableVersions(filteredVersions)
        }
      }
      setFormData((prev) =>({
        ...prev,
        productVersion:''
      }))
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevError) =>({
      ...prevError,
      [name]:null
    }))
  };

  const handleBatchNumberChange = (value) => {
    setFormData(prev => ({ ...prev, batchNumber: value }));
    setIsAddBatchClick(false);
    setErrors((prevError) =>({
      ...prevError,
      batchNumber:null
    }))
  };

  const keyPress = (e) => {
    if (e.keyCode == 13) {
      console.log(e.target.value)
      setIsAddBatchClick(false);
      batches.push(e.target.value);
      setSelectedBatch(e.target.value)
      setBatchError(false);
      setFormData({
        ...formData,
        batchNumber: e.target.value
      });
    }
  }

  const validate = () => {
    let error: any = {}

    if (!formData.id.trim()) {
      error.id = 'Device Id is required';
    } else if (
      formType !== "EDIT" &&
      allDevices.some(device => device.id === formData.id.trim())
    ) {
      error.id = 'Device Id already exists';
    }

    if (!formData.name.trim()) {
      error.name = 'Device Name is required';
    } else if (
      formType !== "EDIT" &&
      allDevices.some(device => device.name === formData.name.trim())
    ) {
      error.name = 'Device Name already exists';
    }

    if (!formData.interval.trim()) {
      error.interval = 'Interval is required';
    } else if (isNaN(Number(formData.interval))) {
      error.interval = 'Interval must be a number';
    }

    if (sensorsOfDevice.length === 0 && actuatorsOfDevice.length === 0) {
      error.sensorCodes = 'At least one Sensor or Actuator must be added';
      error.actuatorCodes = 'At least one Sensor or Actuator must be added';
    }

    if (!formData.batchNumber.trim()) {
      error.batchNumber = 'Batch Number is required';
    }

    if (!formData.protocol.trim()) {
      error.protocol = 'Protocol is required';
    } else if (!isProtocolAdded) {
      error.protocol = 'A protocol must be added to the device';
      setCredentialsError(true);
      setAddCredentialsSuccess(false);
    }

    if (!formData.connectivity.trim()) {
      error.connectivity = 'Connectivity is required';
    }

    if (!formData.productType.trim()) {
      error.productType = 'Product Type is required';
    } else if (
      formType !== "EDIT" &&
      !allProducts.some(product => product.productName === formData.productType)
    ) {
      error.productType = 'Invalid Product Type';
    }

    if (otaUpgradable && !formData.productVersion.trim()) {
      error.productVersion = 'Version is required';
    }

    return error;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    const validationErrors = validate();
    console.log("Validation Errors:", validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({
      id: null,
      name: null,
      interval: null,
      persistence: null,
      protocol: null,
      connectivity: null,
      batchNumber: null,
      sensorCodes: null,
      actuatorCodes: null,
      productType: null,
      productVersion :null,
      deviceModel: null,
      location: null
    });
    const finalData = {
      ...formData,
      deviceModel: formData.deviceModel || '',
      sensorCodes: sensorsOfDevice,
      actuatorCodes: actuatorsOfDevice,
      persistence: formData.persistence,
      noOfSensors: sensorsOfDevice.length,
      noOfActuators: actuatorsOfDevice.length,
      metaData: {
        simNumber: formData.simNumber || null,
        location: formData.location || ''
      },
    };

    onSubmit(finalData);
  };

  const handleSuccess = (success) => {
    console.log("Credentials Success:", success);
    if (success) {
      setCredentialsError(false);
      setAddCredentialsSuccess(true);
      setIsProtocolAdded(true);
    } else {
      setCredentialsError(true);
      setAddCredentialsSuccess(false);
      setIsProtocolAdded(false);
    }
  };

  const handleAdd = () => {
    setIsAddPopupOpen(true);
  }

  return (
    <div className="modal_HighZindex2">
      <div className="modal-dialog">
        <div className="modal-content" style={{minWidth:'800px'}}>
          <div className="modal-header">
            {formType === "ADD" ? 'Add New' : formType === "CLONE" ? 'Clone' : 'Edit'} Device
            <button
              type="button"
              className="modal-close"
              onClick={() => {
                onClose();
              }}
            >
              &times;
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body"  style={{ paddingBottom: "20px" }}>
              {/* Device Id */}
              <div className="form-entity custom-form-entity">
                <div className="form-field">
                  <label className="form-label" htmlFor="deviceIdInput">
                    Device Id (IMEI) <span className="required-asterisk" style={{color: "red"}}>*</span>
                  </label>
                  <input
                    id="deviceIdInput"
                    name="id"
                    value={formData.id}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter Device Id"
                    type="text"
                  />
                  {errors.id && <span className="form-error">{errors.id}</span>}
                </div>

                {/* Device Name */}
                <div className="form-field">
                  <label className="form-label" htmlFor="deviceNameInput">
                    Device Name <span className="required-asterisk" style={{color: "red"}}>*</span>
                  </label>
                  <input
                    id="deviceNameInput"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter Device Name"
                    type="text"
                  />
                  {errors.name && <span className="form-error">{errors.name}</span>}
                </div>
              </div>

              {/* Product Type */}
              <div className="form-entity custom-form-entity">
                <div className="form-field" style={{marginTop:'0px'}}>
                  <label className="form-label" htmlFor="productSelect">
                    Product Type <span className="required-asterisk" style={{color: "red"}}>*</span>
                  </label>
                  <SearchableSelect
                    options={allProducts.map(p => p.productName)}
                    value={formData.productType}
                    onChange={(val) => handleInputChange({ target: { name: 'productType', value: val } } as any)}
                    placeholder="Search Product Type"
                  />
                  {errors.productType && <span className="form-error">{errors.productType}</span>}
                </div>
                {formData.productType && otaUpgradable && (
                  <div className="form-field">
                    <label className="form-label">
                      Version
                    </label>
                    <div className="form-label-container">
                      <select
                        className="form-input selector"
                        name="productVersion"
                        value={formData.productVersion}
                        onChange={handleInputChange}
                        disabled={!formData.productType}
                      >
                        <option value="" disabled hidden>Select Version</option>
                        {selectedProductTypeDetails &&
                          availableVersions.length > 0 &&
                          availableVersions.map((version, index) => (
                            <option key={index} value={version.versionNum}>
                              {version.versionNum}
                            </option>
                          ))}
                      </select>
                      <button
                        type="button"
                        className="btn btn-default"
                        style={{ backgroundColor: '#2A7CED', color: 'white', marginRight: '0px' }}
                        onClick={handleAdd}
                      >
                        + Add New Version
                      </button>
                    </div>
                    {errors.productVersion && (
                      <span className="form-error">{errors.productVersion}</span>
                    )}
                  </div>
                )}
              </div>

              {formData.productType && isAdding && (
                <>
                  {formData.protocol === "MQTT" && (
                    <MQTTProtocol
                      protocol={formData.protocol}
                      onSuccess={handleSuccess}
                      credentialsError={credentialsError}
                      setClientId={setClientId}
                      setLoading={setLoading}
                    />
                  )}
                  {formData.protocol === "HTTP" && (
                    <HTTPProtocol
                      protocol={formData.protocol}
                      onSuccess={handleSuccess}
                      credentialsError={credentialsError}
                      setCredentialsError={setCredentialsError}
                      setClientId={setClientId}
                      setLoading={setLoading}
                    />
                  )}
                </>
              )}

              {/* Model ID & Location */}
              <div className="form-entity custom-form-entity">
                <div className="form-field">
                  <label className="form-label" htmlFor="deviceModelInput">
                    Model ID (optional)
                  </label>
                  {formType === "EDIT" ? (
                    <AddableSelect
                      id="deviceModelInput"
                      value={formData.deviceModel || ''}
                      options={modelOptions}
                      onChange={(val) => handleInputChange({ target: { name: 'deviceModel', value: val } } as any)}
                      onAddOption={handleAddModelOption}
                      placeholder="Select Model ID"
                      addButtonLabel="Add New Model ID"
                      inputPlaceholder="Enter model ID here"
                    />
                  ) : (
                    <input
                      id="deviceModelInput"
                      name="deviceModel"
                      value={formData.deviceModel || ''}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="Enter Model ID"
                      type="text"
                    />
                  )}
                  {errors.deviceModel && <span className="form-error">{errors.deviceModel}</span>}
                </div>
                <div className="form-field">
                  <label className="form-label" htmlFor="locationInput">
                    Location (optional)
                  </label>
                  {formType === "EDIT" ? (
                    <AddableSelect
                      id="locationInput"
                      value={formData.location || ''}
                      options={locationOptions}
                      onChange={(val) => handleInputChange({ target: { name: 'location', value: val } } as any)}
                      onAddOption={handleAddLocationOption}
                      placeholder="Select Location"
                      addButtonLabel="Add New Location"
                      inputPlaceholder="Enter location here"
                    />
                  ) : (
                    <input
                      id="locationInput"
                      name="location"
                      value={formData.location || ''}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="Enter Location"
                      type="text"
                    />
                  )}
                  {errors.location && <span className="form-error">{errors.location}</span>}
                </div>
              </div>

              {/* Interval */}
              <div className="form-entity custom-form-entity">
                <div className="form-field">
                  <label className="form-label" htmlFor="intervalInput">
                    Interval (Minutes) <span className="required-asterisk" style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    id="intervalInput"
                    name="interval"
                    value={formData.interval}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter Interval"
                    type="text"
                  />
                  {errors.interval && <span className="form-error">{errors.interval}</span>}
                </div>

                {/* Batch */}
                <div className="form-field">
                  <label className="form-label" htmlFor="batchInput">
                    Batch <span className="required-asterisk" style={{color: "red"}}>*</span>
                  </label>

                  <div className='form-label-container'>
                    <SearchableSelect
                      options={batches}
                      value={formData.batchNumber}
                      onChange={(val) => handleBatchNumberChange(val)}
                      placeholder="Search Batch Number"
                    />
                    <button
                      type="button"
                      className="btn btn-default"
                      style={{ backgroundColor: '#2A7CED', color: 'white', marginRight: '0px' }}
                      onClick={() => setIsAddBatchClick(true)}
                    >
                      New
                    </button>
                  </div>

                  {/* Show input when "New" is clicked */}
                  {isAddBatchClick && (
                    <input
                      className={style.formInput}
                      type="text"
                      placeholder="Enter New Batch"
                      name="batchNumber"
                      onKeyDown={(e) => keyPress(e)}
                    />
                  )}
                  {errors.batchNumber && <span className="form-error">{errors.batchNumber}</span>}
                </div>
              </div>

              
              </div>

              <div className="modal-footer-new">
                <button
                  type="submit"
                  className="btn btn-default"
                  style={{ backgroundColor: '#2A7CED', color: 'white' }}
                >
                  {formType === "ADD" ? 'Add ' : formType === "CLONE" ? 'Clone' : 'Update'} Device
                </button>
              </div>
          </form>
        </div>
      </div>
      <ToasterComponent
        reqSuccess={reqSuccess}
        message={toasterMessage}
        toaster={isToasterOpen}
      />
    </div>
  );
}